import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Trip, CreateTripRequest, TripStatus } from '../types';

export const tripService = {
  getAll: async (): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>(API_ENDPOINTS.TRIPS.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<Trip> => {
    const response = await apiClient.get<Trip>(API_ENDPOINTS.TRIPS.BY_ID(id));
    return response.data;
  },

  getByStatus: async (status: TripStatus): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>(API_ENDPOINTS.TRIPS.BY_STATUS(status));
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>(API_ENDPOINTS.TRIPS.DATE_RANGE, {
      params: { startDate, endDate },
    });
    return response.data;
  },

  create: async (data: CreateTripRequest): Promise<Trip> => {
    const response = await apiClient.post<Trip>(API_ENDPOINTS.TRIPS.BASE, data);
    return response.data;
  },

  start: async (id: number, startOdometer: number): Promise<Trip> => {
    const response = await apiClient.post<Trip>(
      API_ENDPOINTS.TRIPS.START(id),
      null,
      { params: { startOdometer } }
    );
    return response.data;
  },

  complete: async (id: number, endOdometer: number): Promise<Trip> => {
    const response = await apiClient.post<Trip>(
      API_ENDPOINTS.TRIPS.COMPLETE(id),
      null,
      { params: { endOdometer } }
    );
    return response.data;
  },

  getByDriver: async (driverId: number): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>(API_ENDPOINTS.TRIPS.BY_DRIVER(driverId));
    return response.data;
  },

  updateAmount: async (id: number, amount: number): Promise<Trip> => {
    const response = await apiClient.put<Trip>(
      API_ENDPOINTS.TRIPS.UPDATE_AMOUNT(id),
      null,
      { params: { amount } }
    );
    return response.data;
  },
};
